// extracted by mini-css-extract-plugin
export default {"container":"REpHCJ","wrapper":"_EFnvm","logo":"P8Y3jV","message":"AdrMKC","mobile":"WU9BYR"};